module.exports = __webpack_public_path__ + "img/startup-ventures.11b9dd31.jpg";